import axios from 'axios';
import { captureException } from '@sentry/react';

import { TRADE_IN_ACTIONS } from './constants';

export const fetchTradeInTexts = () => ({
  type: TRADE_IN_ACTIONS.FETCH_TRADE_IN,
});

export const fetchTradeInTextsSuccess = (payload) => ({
  type: TRADE_IN_ACTIONS.FETCH_TRADE_IN_SUCCESS,
  payload,
});

export const fetchTradeInTextsError = () => ({
  type: TRADE_IN_ACTIONS.FETCH_TRADE_IN_ERROR,
});

export const fetchTradeInTextsThunk = () => async (dispatch) => {
  try {
    dispatch(fetchTradeInTexts());

    const { data } = await axios.get('/shop/sitetext/?key=SHOP_TRADE_IN_CONTENT_TEXTS');
    const stringData = data.replace(/\s/g, ' ').match(/\{(.*)\}/);
    const texts = JSON.parse(stringData[0]);

    dispatch(fetchTradeInTextsSuccess(texts));
  } catch (error) {
    captureException(error);
    dispatch(fetchTradeInTextsError());
  }
};
